module.exports = __webpack_public_path__ + "static/img/solutionHome.af43d82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solutionHome.png
// module id = yfj0
// module chunks = 2